/*
  Waifu Overlord landing page (Black November 2026)
  1. Countdown        every [data-ovl-countdown], end time from [data-ovl-end] on the hero
  2. Day badge        LIVE / BLACK FRIDAY (Nov 27) / LAST CALL (Nov 30), by US Eastern date
  3. Lazy videos      download + play only near the screen, pause when off screen
  4. Sticky bar       shows after the hero button scrolls away
  5. Drag to scroll   Reddit rail with a mouse
  6. UTM pass-through ad tracking params carried onto every Make Me Overlord link
  7. Fit text         keeps the hero badges and title on one line on phones
  8. Past boxes       the TOB and WCC rows: scroll by themselves, stop for the shopper, tap a box to see it bigger
*/
(function () {
  'use strict';

  var d = document;
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- 1. Countdown ---------- */
  var countdownTimer = null;
  function initCountdown() {
    if (countdownTimer) clearInterval(countdownTimer);
    var src = d.querySelector('[data-ovl-end]');
    var roots = d.querySelectorAll('[data-ovl-countdown]');
    if (!src || !roots.length) return;
    var end = Date.parse(src.getAttribute('data-ovl-end'));
    if (isNaN(end)) return;

    var cells = [];
    Array.prototype.forEach.call(roots, function (root) {
      for (var i = 0; i < 4; i++) {
        var el = root.querySelector('[data-unit="' + i + '"]');
        if (el) cells.push({ el: el, unit: i });
      }
    });

    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var v = [Math.floor(s / 86400), Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60].map(pad);
      for (var i = 0; i < cells.length; i++) {
        var t = v[cells[i].unit];
        if (cells[i].el.textContent !== t) cells[i].el.textContent = t;
      }
      if (s <= 0 && countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
        d.documentElement.classList.add('ovl-ended');
      }
    }
    countdownTimer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- 2. Day badge ---------- */
  function initDayBadge() {
    var hero = d.querySelector('[data-ovl-badge-mode]');
    var badge = d.querySelector('[data-ovl-day-badge]');
    if (!hero || !badge || hero.getAttribute('data-ovl-badge-mode') !== 'auto') return;
    var md;
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
      var month = 0, day = 0;
      parts.forEach(function (p) {
        if (p.type === 'month') month = parseInt(p.value, 10);
        if (p.type === 'day') day = parseInt(p.value, 10);
      });
      md = month * 100 + day;
    } catch (e) { return; }
    badge.textContent = md === 1127 ? 'BLACK FRIDAY' : md === 1130 ? 'LAST CALL' : 'LIVE';
  }

  /* ---------- 3. Lazy videos ---------- */
  function loadVideo(v) {
    if (v.getAttribute('data-loaded')) return;
    v.setAttribute('data-loaded', '1');
    Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function (s) {
      s.src = s.getAttribute('data-src');
      s.removeAttribute('data-src');
    });
    if (reduceMotion.matches) {
      // No autoplay: show the first frame instead (iOS needs a tiny seek to paint it)
      v.addEventListener('loadedmetadata', function () { try { v.currentTime = 0.01; } catch (e) {} }, { once: true });
    }
    v.load();
  }
  function playVideo(v) {
    if (reduceMotion.matches) return;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }
d.addEventListener('ended', function (e) { var v = e.target; if (v && v.tagName === 'VIDEO' && v.hasAttribute('loop')) { try { v.currentTime = 0; } catch (err) {} playVideo(v); } }, true); // Safari: WebM <video loop> stops after the first play (WebKit bug), so restart it manually
  var videoIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { loadVideo(v); playVideo(v); }
      else if (!v.paused) v.pause();
    });
  }, { rootMargin: '250px 0px' }) : null;

  function initVideos(scope) {
    Array.prototype.forEach.call((scope || d).querySelectorAll('video[data-ovl-video]'), function (v) {
      if (v.closest('[data-ovl-sticky]')) return; // the sticky bar handles its own videos
      if (v.hasAttribute('data-eager')) {
        v.setAttribute('data-loaded', '1'); // sources already set in the markup, autoplaying
        if (reduceMotion.matches) v.pause();
      }
      if (videoIO) videoIO.observe(v);
      else { loadVideo(v); playVideo(v); }
    });
  }

  /* ---------- 4. Sticky bar ---------- */
  var stickyIO = null;
  function initSticky() {
    if (stickyIO) { stickyIO.disconnect(); stickyIO = null; }
    var bar = d.querySelector('[data-ovl-sticky]');
    if (!bar) return;
    var vids = Array.prototype.slice.call(bar.querySelectorAll('video[data-ovl-video]'));
    var shown = bar.classList.contains('is-visible');

    function syncVideos() {
      vids.forEach(function (v) {
        if (shown && v.getClientRects().length) { loadVideo(v); playVideo(v); }
        else if (!v.paused) v.pause();
      });
    }
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('is-visible', on);
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      syncVideos();
    }
    bar._ovlSetShown = setShown;

    var trigger = d.querySelector('.ovl-hero__cta .ovl-btn') || d.querySelector('[data-ovl-hero]');
    if (trigger && hasIO) {
      stickyIO = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        // Show once the hero button has scrolled up past the top of the screen
        setShown(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      stickyIO.observe(trigger);
    } else {
      var onScroll = function () { setShown(window.scrollY > 700); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 1024px)');
      var onChange = function () { syncVideos(); };
      if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
    }
  }

  /* ---------- 5. Drag to scroll (mouse only; touch scrolls natively) ---------- */
  function initDrag(scope) {
    Array.prototype.forEach.call((scope || d).querySelectorAll('[data-ovl-drag]'), function (rail) {
      if (rail._ovlDrag) return;
      rail._ovlDrag = true;
      var down = false, moved = false, startX = 0, startLeft = 0;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft;
      });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true;
          rail.classList.add('is-dragging');
          try { rail.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) { rail.scrollLeft = startLeft - dx; e.preventDefault(); }
      });
      var end = function () {
        if (!down) return;
        down = false;
        if (moved) {
          // Let snapping settle after the drag
          rail.classList.remove('is-dragging');
          setTimeout(function () { moved = false; }, 0);
        }
      };
      rail.addEventListener('pointerup', end);
      rail.addEventListener('pointercancel', end);
      rail.addEventListener('lostpointercapture', end);
      rail.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- 7. Keep one-line text on one line ----------
     [data-ovl-fit] elements are sized in CSS to fit the current copy. If edited copy (or the
     BLACK FRIDAY / LAST CALL badge) runs longer, shrink the font just enough to stay on one line. */
  function fitText() {
    Array.prototype.forEach.call(d.querySelectorAll('[data-ovl-fit]'), function (el) {
      el.style.fontSize = '';
      var avail = el.clientWidth, need = el.scrollWidth;
      if (avail && need > avail + 1) {
        var fs = parseFloat(window.getComputedStyle(el).fontSize);
        el.style.fontSize = Math.max(8, Math.floor(fs * (avail / need) * 0.99 * 100) / 100) + 'px';
      }
    });
  }
  function initFit() {
    fitText();
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(fitText);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fitText, 120); }, { passive: true });
  }

  /* ---------- 6. UTM pass-through ---------- */
  function initUtm(scope) {
    if (!location.search || typeof URLSearchParams === 'undefined') return;
    var keep = [];
    new URLSearchParams(location.search).forEach(function (val, key) {
      if (/^(utm_|gclid$|gbraid$|wbraid$|fbclid$|ttclid$|msclkid$|sca_ref$|ref$)/i.test(key)) keep.push([key, val]);
    });
    if (!keep.length) return;
    Array.prototype.forEach.call((scope || d).querySelectorAll('a[data-ovl-cta]'), function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.href);
        if (u.origin !== location.origin) return;
        keep.forEach(function (kv) { if (!u.searchParams.has(kv[0])) u.searchParams.set(kv[0], kv[1]); });
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  /* ---------- 8. Past boxes ----------
     A row of past boxes that scrolls by itself, slowly, while it's on screen. It stops while the cursor is over it,
     and when it's touched, dragged, scrolled, used with the keyboard or moved with the arrows, then starts again
     a few seconds after. A mouse can drag it. At the last box it waits, then glides back to the first.
     Tap or click a box to see it bigger, with previous / next (arrows, arrow keys or a swipe).
     No auto-scroll for people who ask for less motion (they can still swipe and use the arrows). */
  var PAST_SPEED = 36;   // px per second
  var PAST_IDLE = 4000;  // ms after the shopper's last touch, drag, scroll or arrow before it moves again
  var PAST_END = 1600;   // ms it waits at the last box before going back to the first
  function initPast(scope) {
    Array.prototype.forEach.call((scope || d).querySelectorAll('[data-ovl-past]'), function (sec) {
      if (sec._ovlPast) return;
      sec._ovlPast = true;
      var sc = sec.querySelector('[data-ovl-past-rail]');
      if (!sc) return;
      var items = Array.prototype.slice.call(sc.querySelectorAll('[data-ovl-past-card]'));
      var prevBtn = sec.querySelector('[data-ovl-past-prev]');
      var nextBtn = sec.querySelector('[data-ovl-past-next]');
      var onScreen = !hasIO, hover = false, keys = false, dragging = false, viewing = false, restoring = false;
      var raf = 0, last = 0, pos = 0, setTo = -1, waitT = 0, busy = false, quietUntil = 0;

      function maxLeft() { return Math.max(0, sc.scrollWidth - sc.clientWidth); }
      function step() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : sc.clientWidth; }
      function canRun() { return onScreen && !hover && !keys && !dragging && !viewing && !reduceMotion.matches; }
      function wait(ms, fn) { clearTimeout(waitT); waitT = setTimeout(fn, ms); }
      function halt() { if (raf) window.cancelAnimationFrame(raf); raf = 0; last = 0; }
      function run() {
        if (raf || busy || !canRun()) return;
        var quiet = quietUntil - Date.now();
        if (quiet > 0) { wait(quiet + 50, run); return; }
        if (maxLeft() < 2) return;
        pos = sc.scrollLeft; setTo = -1; last = 0;
        raf = window.requestAnimationFrame(frame);
      }
      function frame(t) {
        raf = 0;
        if (!canRun()) return;
        // Moved by the shopper since the last step (trackpad, keyboard...)
        if (setTo >= 0 && Math.abs(sc.scrollLeft - setTo) > 2) { shopper(); return; }
        var dt = last ? Math.min(0.05, (t - last) / 1000) : 0;
        last = t;
        var end = maxLeft();
        pos = Math.min(end, pos + PAST_SPEED * dt);
        sc.scrollLeft = pos;
        setTo = sc.scrollLeft;
        if (pos >= end - 0.5) { busy = true; wait(PAST_END, rewind); return; }
        raf = window.requestAnimationFrame(frame);
      }
      function rewind() {
        if (!canRun()) { busy = false; return; }
        sc.scrollTo({ left: 0, behavior: 'smooth' });
        var tries = 0;
        (function check() {
          if (sc.scrollLeft < 2 || ++tries > 30) { busy = false; setTo = -1; wait(900, run); return; }
          waitT = setTimeout(check, 100);
        })();
      }
      // The shopper took over: stop, and start again after a quiet moment
      function shopper() {
        halt();
        busy = false;
        quietUntil = Date.now() + PAST_IDLE;
        wait(PAST_IDLE + 50, run);
      }

      // Arrows: one box at a time
      function syncArrows() {
        if (prevBtn) prevBtn.disabled = sc.scrollLeft < 4;
        if (nextBtn) nextBtn.disabled = sc.scrollLeft > maxLeft() - 4;
      }
      function by(dir) {
        shopper();
        var s = step() || 1;
        var i = Math.round(sc.scrollLeft / s) + dir;
        sc.scrollTo({ left: Math.max(0, Math.min(maxLeft(), i * s)), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { by(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { by(1); });
      var arrowT = 0;
      sc.addEventListener('scroll', function () {
        if (!arrowT) arrowT = window.requestAnimationFrame(function () { arrowT = 0; syncArrows(); });
        if (busy || raf || dragging) return;
        // Any scroll it didn't make itself (momentum after a swipe, too) keeps it paused a little longer
        if (setTo >= 0 && Math.abs(sc.scrollLeft - setTo) <= 2) return;
        quietUntil = Date.now() + PAST_IDLE;
        if (!hover && !keys && !viewing) wait(PAST_IDLE + 50, run);
      }, { passive: true });
      window.addEventListener('resize', syncArrows, { passive: true });
      syncArrows();

      // Cursor over it: pause until it leaves
      sc.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; halt(); } });
      sc.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; if (!busy) wait(700, run); } });
      // Touch, sideways trackpad scroll, keyboard
      sc.addEventListener('touchstart', shopper, { passive: true });
      sc.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) shopper(); }, { passive: true });
      sc.addEventListener('keydown', function (e) { if (/^(Arrow|Page|Home|End)/.test(e.key)) shopper(); });
      sc.addEventListener('focusin', function () { if (viewing || restoring) return; try { keys = sc.matches(':focus-visible') || !!sc.querySelector(':focus-visible'); } catch (err) { keys = false; } if (keys) halt(); });
      sc.addEventListener('focusout', function () { if (keys) { keys = false; shopper(); } });

      // Drag with a mouse (touch scrolls natively)
      var down = false, moved = false, startX = 0, startLeft = 0;
      sc.addEventListener('pointerdown', function (e) {
        shopper();
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = sc.scrollLeft;
      });
      sc.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true; dragging = true;
          sc.classList.add('is-dragging');
          try { sc.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) { sc.scrollLeft = startLeft - dx; e.preventDefault(); }
      });
      function release() {
        if (!down) return;
        down = false;
        if (moved) {
          dragging = false;
          sc.classList.remove('is-dragging');
          setTimeout(function () { moved = false; }, 0);
        }
        shopper();
      }
      sc.addEventListener('pointerup', release);
      sc.addEventListener('pointercancel', release);
      sc.addEventListener('lostpointercapture', release);
      sc.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      sc.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Bigger view
      var lb = sec.querySelector('[data-ovl-past-lb]');
      if (lb && typeof lb.showModal === 'function') {
        var lbImg = lb.querySelector('[data-ovl-lb-img]');
        var lbTitle = lb.querySelector('[data-ovl-lb-title]');
        var lbCount = lb.querySelector('[data-ovl-lb-count]');
        var cards = items.map(function (li) { return li.querySelector('[data-ovl-past-open]'); });
        var at = 0;
        var show = function (i) {
          at = (i + cards.length) % cards.length;
          var c = cards[at];
          lbImg.loading = 'eager';
          lbImg.src = c.getAttribute('data-full');
          lbImg.alt = c.getAttribute('data-alt') || '';
          lbTitle.textContent = c.getAttribute('data-title') || '';
          lbCount.textContent = (at + 1) + ' / ' + cards.length;
          // Have the next one ready
          var n = cards[(at + 1) % cards.length];
          if (n) { var pre = new Image(); pre.src = n.getAttribute('data-full'); }
        };
        sc.addEventListener('click', function (e) {
          var btn = e.target.closest ? e.target.closest('[data-ovl-past-open]') : null;
          if (!btn) return;
          viewing = true; halt();
          show(cards.indexOf(btn));
          lb.showModal();
        });
        lb.querySelector('[data-ovl-lb-prev]').addEventListener('click', function () { show(at - 1); });
        lb.querySelector('[data-ovl-lb-next]').addEventListener('click', function () { show(at + 1); });
        lb.querySelector('[data-ovl-lb-close]').addEventListener('click', function () { lb.close(); });
        lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
        lb.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
          else if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
        });
        var tx = null;
        lb.addEventListener('touchstart', function (e) { tx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
        lb.addEventListener('touchend', function (e) {
          if (tx === null) return;
          var dx = e.changedTouches[0].clientX - tx; tx = null;
          if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1));
        }, { passive: true });
        lb.addEventListener('close', function () {
          viewing = false;
          // Focus goes back to the box they opened; that alone shouldn't keep the row paused
          restoring = true;
          setTimeout(function () { restoring = false; }, 0);
          // Leave the row on the box they looked at last
          sc.scrollTo({ left: Math.min(maxLeft(), at * step()), behavior: 'auto' });
          shopper();
        });
      }

      // Start when it comes on screen, stop when it leaves
      if (hasIO) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            onScreen = en.isIntersecting;
            if (onScreen) { if (!busy) wait(600, run); } else { halt(); }
          });
        }, { threshold: 0.35 }).observe(sc);
      } else {
        wait(600, run);
      }
    });
  }

  function init() {
    initCountdown();
    initDayBadge();
    initFit();
    initVideos();
    initSticky();
    initDrag();
    initPast();
    initUtm();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();

  /* ---------- Theme editor support ---------- */
  if (window.Shopify && window.Shopify.designMode) {
    d.addEventListener('shopify:section:load', function (e) {
      initCountdown();
      initDayBadge();
      fitText();
      initVideos(e.target);
      initDrag(e.target);
      initPast(e.target);
      if (e.target.querySelector('[data-ovl-sticky]') || e.target.querySelector('[data-ovl-hero]')) initSticky();
    });
    d.addEventListener('shopify:section:select', function (e) {
      var bar = e.target.querySelector('[data-ovl-sticky]');
      if (bar && bar._ovlSetShown) bar._ovlSetShown(true);
    });
  }
})();
